module.exports = __webpack_public_path__ + "static/media/elo-30.195ebf1c.svg";